import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDownWideShort,
  faArrowDownShortWide,
  faArrowsUpDown,
} from "@fortawesome/free-solid-svg-icons";

const ColumnSorter = (props) => {
  const { sort_by, header, sort_order, onSortClick } = props;
  const sortIconOnClick = (e) => {
    e.preventDefault();
    const esort_by = header.attr;
    var esort_order = "desc";
    if (sort_by === header.attr) {
      esort_order = sort_order === "asc" ? "desc" : "asc";
    }
    onSortClick(e, esort_by, esort_order);
  };

  const getSortIcon = () => {
    if (sort_by === header.attr) {
      if (sort_order === "desc") {
        return faArrowDownWideShort;
      } else {
        return faArrowDownShortWide;
      }
    } else {
      return faArrowsUpDown;
    }
  };

  return (
    <div className="column-sorter">
      <FontAwesomeIcon
        onClick={sortIconOnClick}
        className="sort-icon"
        icon={getSortIcon()}
      />
    </div>
  );
};
export default ColumnSorter;
